/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TypographyChatActivityUpdatedAt_ChatActivity = {
    readonly updatedAt: unknown | null;
    readonly " $refType": "TypographyChatActivityUpdatedAt_ChatActivity";
};
export type TypographyChatActivityUpdatedAt_ChatActivity$data = TypographyChatActivityUpdatedAt_ChatActivity;
export type TypographyChatActivityUpdatedAt_ChatActivity$key = {
    readonly " $data"?: TypographyChatActivityUpdatedAt_ChatActivity$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyChatActivityUpdatedAt_ChatActivity">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyChatActivityUpdatedAt_ChatActivity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
};
(node as any).hash = '2176b64def65faa8d01c71e375065a11';
export default node;
